import React from "react"
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import whatsapp from "../../../images/sidebar_icon/whatsapp.png";
import candidates from "../../../images/sidebar_icon/graduated.png";


import useStyles from "../styles";
import SidebarLink from "../components/SidebarLink/SidebarLink";

const ShareSidebar = ({ location, isSidebarOpened }) => {
    const classes = useStyles();
    const shareItems = [
        {
            id: 0,
            label: "Candidates",
            type: "title",
            link: "#",
            view: true,
            icon: (
                <Tooltip title="Candidates" placement="right">
                    <IconButton>
                        <img
                            src={candidates}
                            alt="candidates"
                            className={classNames(classes.Icon3)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];
    return (
        <>
            {
                shareItems.map((link) => (
                    <SidebarLink
                        key={link.id}
                        location={location}
                        isSidebarOpened={isSidebarOpened}
                        {...link}
                    />
                ))
            }
        </>
    );
}


const ChatSidebar = ({ location, isSidebarOpened }) => {
    const classes = useStyles();
    const chatItems = [
        {
            id: 0,
            label: "Chat",
            link: "/app/singlechat",
            view: true,
            icon: (
                <Tooltip title="Chat" placement="right">
                    <IconButton>
                        <img
                            src={whatsapp}
                            alt="whatsapp"
                            className={classNames(classes.Icon4)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];
    return (
        <>
            {
                chatItems.map((link) => (
                    <SidebarLink
                        key={link.id}
                        location={location}
                        isSidebarOpened={isSidebarOpened}
                        {...link}
                    />
                ))
            }
        </>
    );
}


export {
    ChatSidebar,
    ShareSidebar,
}